export default {"src":"/_next/static/media/boc-rang-su.d3306755.svg","height":100,"width":101,"blurWidth":0,"blurHeight":0};